<div class="form-fields" [class.form-fields_error]="hasError()" [class.form-fields_inline]="isInline">
    <label class="form-fields__label">
        {{ label }}
        <span class="form-fields__req" *ngIf="required">*</span>
    </label>
    <div class="form-fields__control">
        <ng-content></ng-content>
        <div class="form-fields__error">
            <ng-container *ngIf="control && errorKey" [ngSwitch]="errorKey">
                <span *ngSwitchCase="'min'">Minimum {{control?.errors[errorKey].min}}</span>
                <span *ngSwitchCase="'max'">Maximum {{control?.errors[errorKey].max}}</span>
                <span *ngSwitchCase="'required'">This field is required</span>
                <span *ngSwitchCase="'requiredtrue'">This field is required</span>
                <span *ngSwitchCase="'minlength'">At least {{control?.errors[errorKey].requiredLength}} character</span>
                <span *ngSwitchCase="'maxlength'">No more than {{control?.errors[errorKey].requiredLength}} character</span>
                <span *ngSwitchCase="'pattern'">
                    <span *ngIf="patternError">{{patternError}}</span>
                <span *ngIf="!patternError">Pattern dose not match</span>
                </span>
                <span *ngSwitchCase="'min'"></span>
            </ng-container>
        </div>
    </div>
</div>


<!-- <mat-form-fields appearance="standard">
    <mat-label>{{ label }}
        <span class="form-fields__req" *ngIf="required">*</span>
    </mat-label>
    <input matInput class="" placeholder="Placeholder">
    <mat-icon matPrefix>
        <img src="../../../../../assets/images/password.png" class="input-img">
    </mat-icon>
    <ng-content></ng-content>
    <mat-error *ngIf="control && errorKey" [ngSwitch]="errorKey">
        <span *ngSwitchCase="'required'">This field is required</span>
    </mat-error>
</mat-form-fields> -->

<!-- <p>
    <mat-form-fields appearance="standard">
      <mat-label>Standard form field</mat-label>
      <input matInput placeholder="Placeholder">
      <mat-icon matSuffix>
        <img src="../../../../../assets/images/password.png" class="input-img">
    </mat-icon>
      <mat-hint>Hint</mat-hint>
    </mat-form-fields>
  </p> -->
